// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


let yourProfilePages = [
  {
    name: "Personal Information",
    description: "Update your identity, contact details, professional information, and address.",
    url: "/account/profile/basic_info"
  },
  {
    name: "Photos",
    description: "Manage your profile photo and featured photo.",
    url: "/account/profile/photos"
  },
  {
    name: "About You",
    description: "Tell people about your experience and specialties.",
    url: "/account/profile/about"
  },
  {
    name: "Social Media",
    description: "Link your social media accounts.",
    url: "/account/profile/social_media"
  }
];

let teamAccountProfilePages = [
  {
    name: "Basic Information",
    description: "Update the team name, brokerage, and website shown publicly.",
    url: "/account/account_profile/basic_info"
  },
  {
    name: "Photos",
    description: "Manage the team logo and team photo.",
    url: "/account/account_profile/photos"
  },
  {
    name: "About",
    description: "Update the team's public About section.",
    url: "/account/account_profile/about"
  },
  {
    name: "Social Media",
    description: "Link the team's social media accounts.",
    url: "/account/account_profile/social_media"
  },
  {
    name: "Members",
    description: "Manage public visibility, titles, and Display-only members.",
    url: "/account/account_profile/members"
  },
  {
    name: "Custom Profile URL",
    description: "Personalize the public URL for this account.",
    url: "/account/account_profile/url"
  }
];

function accountProfilePages(profileType) {
  if (profileType === "Individual") {
    return [];
  } else {
    return teamAccountProfilePages;
  }
}

function accountProfileName(profileType) {
  if (profileType === "Individual") {
    return "Your Public Profile";
  } else {
    return "Your Team's Profile";
  }
}

exports.yourProfilePages = yourProfilePages;
exports.teamAccountProfilePages = teamAccountProfilePages;
exports.accountProfilePages = accountProfilePages;
exports.accountProfileName = accountProfileName;
/* No side effect */
